angular.module 'zc.core'

.filter "elapseTime", ($filter) ->
  A_DAY = 1000 * 60 * 60 * 24
  (milliseconds) ->
    if 0 <= milliseconds < A_DAY
      $filter('date')(milliseconds, 'HH:mm:ss', 'UTC')
    else if A_DAY <= milliseconds
      '(data too big)'
    else # minus minutes
      "-" + $filter('date')(-milliseconds, 'HH:mm:ss', 'UTC')



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/filters/elapse_time_filter.js.coffee